import { connect } from 'react-redux';
import BasketsReportComponent from './BasketsReportComponent';
import { basketsReportOperations } from './duck';
import { dashboardOperations } from '../../../duck';

const mapStateToProps = (state) => {
    return {
        ...state,
        login: state.login
    }
};

const mapDispatchToProps = (dispatch) => {
    const updateTitle = (title) => dispatch(dashboardOperations.updateTitle(title));
    const getBasketsStats = (dateFrom, dateTo) => dispatch(basketsReportOperations.getBasketsStats(dateFrom, dateTo));
    return {
        updateTitle, 
        getBasketsStats
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(BasketsReportComponent)